import { Modal } from '@mui/material';
import { useMemo } from 'react';

import ReviewSummaryContent from '@/components/Pbl/VolunteerRegistration/ReviewSummaryContent';

import { buildLawyerReviewSummary } from './caseMatchingState';
import {
  ModalCloseButton,
  ReviewSummaryModalScroll,
  ReviewSummaryModalSurface,
} from './styles';
import type { PblOcLawyer } from './types';
import { useTranslation } from 'react-i18next';

type LawyerReviewSummaryModalProps = {
  lawyer: PblOcLawyer | null;
  language: 'en' | 'zh';
  open: boolean;
  onClose: () => void;
};

const LawyerReviewSummaryModal = ({
  lawyer,
  language,
  open,
  onClose,
}: LawyerReviewSummaryModalProps) => {
  //   @ts-ignore
  const { t } = useTranslation();
  const summary = useMemo(
    () => (lawyer ? buildLawyerReviewSummary(lawyer, language) : null),
    [lawyer, language]
  );

  return (
    <Modal open={open && Boolean(summary)} onClose={onClose} disableEnforceFocus>
      <ReviewSummaryModalSurface>
        <ModalCloseButton type="button" aria-label={t('pbl.pagesHardcoded.ocManageCases.lawyerReviewSummaryModal.closeLawyerCvPreview')} onClick={onClose}>
          x
        </ModalCloseButton>
        <ReviewSummaryModalScroll>
          {summary && (
            <ReviewSummaryContent
              form={summary.form}
              serviceAreaLabels={summary.serviceAreaLabels}
              showHeader={false}
              showEditLinks={false}
              showSubmitNotice={false}
              firmAuthorisationFileName="Law firm authorisation.pdf"
              conductSupportingDocumentNames={[]}
              hideSectionsFromAuthorisation
            />
          )}
        </ReviewSummaryModalScroll>
      </ReviewSummaryModalSurface>
    </Modal>
  );
};

export default LawyerReviewSummaryModal;
